import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useRenumerationModal } from '../context/RenumerationModalContext';

const RenumerationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useRenumerationModal();

  const hasValidDate = data.date && data.date >= data.lastOperationDate;

  const buttonEnabledScriptureView = data.scriptureView && hasValidDate;
  const buttonEnabledMovementsView = !data.scriptureView;
  const buttonText = data.scriptureView ? t('Next') : t('SaveOperation');

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveRenumeration}
          disabled={!buttonEnabledScriptureView && !buttonEnabledMovementsView}
        >
          {buttonText}
        </button>
      </Modal.Footer>
    </>
  );
};

export default RenumerationModalFooter;
